import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { makeStyles, useTheme } from "@material-ui/core/styles";

import Checkbox from "@material-ui/core/Checkbox";

import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";

import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";

const useStyles = makeStyles(theme => ({
  SwitchLabel: {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.75rem"
    }
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
    fontSize: "0.75rem"
  }
}));

const ITEM_HEIGHT = 48;

const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    fontSize: "0.75rem"
  };
}

const ProvidersTasks = ({
  type,
  onChange,
  disabled,
  onDelete,
  value,
  error,
  children,
  title,
  tasks,
  tasks_data,
  provider_data,
  gamas,
  brands,
  tier_brands,
  performed_types,
  vehicle_types,
  equipment_types,
  additional_services,
  removeItem,
  addNewItem,
  ...props
}) => {
  const theme = useTheme();

  const handleChange = event => {
    onChange(event, "tasks_data");
  };

  const handleDelete = (type, value) => {
    if (disabled) {
      return;
    }

    onDelete(type, value);
  };

  const onMouseDown = e => {
    e.stopPropagation();
  };

  const classes = useStyles();

  const handleAddItem = event => {
    event.preventDefault();
    event.stopPropagation();
    addNewItem("tasks_data");
  };

  const handleRemoveItem = (event, idx) => {
    event.preventDefault();
    event.stopPropagation();
    removeItem("tasks_data", idx);
  };

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>
      <div className="row">
        <FormControlLabel
          className={classes.SwitchLabel}
          control={
            <Switch
              id="is_official"
              value={tasks_data.is_official}
              checked={tasks_data.is_official}
              disabled={disabled}
              onChange={handleChange}
              name="is_official"
              size="small"
              color="primary"
              className="mr-4"
            />
          }
          label="Es taller oficial?"
          labelPlacement="start"
        />
        <FormControlLabel
          className={classes.SwitchLabel}
          control={
            <Switch
              id="has_crane"
              value={tasks_data.has_crane}
              checked={tasks_data.has_crane}
              disabled={disabled}
              onChange={handleChange}
              name="has_crane"
              size="small"
              color="primary"
              className="mr-4"
            />
          }
          label="Ofrece grua?"
          labelPlacement="start"
        />
        <FormControlLabel
          className={classes.SwitchLabel}
          control={
            <Switch
              id="has_valet"
              value={tasks_data.has_valet}
              disabled={disabled}
              checked={tasks_data.has_valet}
              name="has_valet"
              onChange={handleChange}
              size="small"
              color="primary"
              className="mr-4"
            />
          }
          label="Ofrece valet?"
          labelPlacement="start"
        />
        <FormControlLabel
          className={classes.SwitchLabel}
          control={
            <Switch
              id="tasks_data.has_safe_items"
              disabled={disabled}
              value={tasks_data.has_safe_items}
              checked={tasks_data.has_safe_items}
              name="has_safe_items"
              onChange={handleChange}
              size="small"
              color="primary"
              className="mr-4"
            />
          }
          label="Ofrece elementos seguros?"
          labelPlacement="start"
        />
        <FormControlLabel
          className={classes.SwitchLabel}
          control={
            <Switch
              id="has_iso_certification"
              value={tasks_data.has_iso_certification}
              checked={tasks_data.has_iso_certification}
              disabled={disabled}
              onChange={handleChange}
              name="has_iso_certification"
              size="small"
              color="primary"
              className="mr-4"
            />
          }
          label="Homologado para ISO 14001"
          labelPlacement="start"
        />
      </div>
      <TextField
        disabled={disabled}
        id="q_daily_operations"
        name="q_daily_operations"
        type="number"
        label="Cant. Operaciones"
        placeholder="Ingrese la cantidad de operaciones diarias"
        onChange={handleChange}
        value={tasks_data.q_daily_operations}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ min: "0", style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <FormControl className={classes.formControl}>
        <InputLabel style={{ fontSize: "0.75rem" }}>Marcas</InputLabel>
        <Select
          labelId="demo-mutiple-chip-label"
          id="brands"
          name="brands"
          onClick={e => e.preventDefault()}
          multiple
          value={tasks_data.brands}
          onChange={e => {
            handleChange(e);
          }}
          disabled={disabled}
          input={<Input id="select-multiple-chip" />}
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(value => (
                <Chip
                  key={value}
                  label={value}
                  className={classes.chip}
                  tabIndex={-1}
                  clickeable={true}
                  onDelete={
                    provider_data.brands !== null &&
                    provider_data.brands !== undefined
                      ? provider_data.brands.find(o => o.name === value)
                        ? e => {
                            handleDelete("brands", value);
                          }
                        : false
                      : ""
                  }
                  onMouseDown={e => {
                    onMouseDown(e);
                  }}
                />
              ))}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {brands.map(brand => (
            <MenuItem
              key={brand.id}
              data-id={brand.id}
              dataid={brand.id}
              id={brand.id}
              value={brand.name}
              style={getStyles(brand.name, brand.name, theme)}
            >
              <Checkbox
                className="pr-4"
                color="primary"
                checked={tasks_data.brands.indexOf(brand.name) > -1}
                style={{ height: 0, width: 0 }}
              />
              {brand.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel style={{ fontSize: "0.75rem" }}>
          Marcas cubiertas
        </InputLabel>
        <Select
          labelId="demo-mutiple-chip-label"
          id="tier_brands"
          name="tier_brands"
          onClick={e => e.preventDefault()}
          multiple
          value={tasks_data.tier_brands}
          onChange={e => {
            handleChange(e);
          }}
          disabled={disabled}
          input={<Input id="select-multiple-chip" />}
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(value => (
                <Chip
                  key={value}
                  label={value}
                  className={classes.chip}
                  tabIndex={-1}
                  clickeable={true}
                  onDelete={
                    provider_data.brands !== null &&
                    provider_data.brands !== undefined
                      ? provider_data.brands.find(o => o.name === value)
                        ? e => {
                            handleDelete("brands", value);
                          }
                        : false
                      : ""
                  }
                  onMouseDown={e => {
                    onMouseDown(e);
                  }}
                />
              ))}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {tier_brands.map(brand => (
            <MenuItem
              key={brand.id}
              data-id={brand.id}
              dataid={brand.id}
              id={brand.id}
              value={brand.name}
              style={getStyles(brand.name, brand.name, theme)}
            >
              <Checkbox
                className="pr-4"
                color="primary"
                checked={tasks_data.tier_brands.indexOf(brand.name) > -1}
                style={{ height: 0, width: 0 }}
              />
              {brand.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel style={{ fontSize: "0.75rem" }}>Gama</InputLabel>
        <Select
          labelId="demo-mutiple-chip-label"
          id="gamas"
          name="gamas"
          multiple
          disabled={disabled}
          value={tasks_data.gamas}
          onChange={e => {
            handleChange(e);
          }}
          input={<Input id="select-multiple-chip" />}
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(value => (
                <Chip
                  key={value}
                  label={value}
                  className={classes.chip}
                  clickeable={true}
                  onDelete={
                    provider_data.gamas !== null &&
                    provider_data.gamas !== undefined
                      ? provider_data.gamas.find(o => o.name === value)
                        ? e => {
                            handleDelete("gamas", value);
                          }
                        : false
                      : ""
                  }
                  onMouseDown={e => {
                    onMouseDown(e);
                  }}
                />
              ))}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {gamas.map(gama => (
            <MenuItem
              key={gama.id}
              value={gama.name}
              style={getStyles(gama.name, gama.name, theme)}
            >
              <Checkbox
                className="pr-4"
                color="primary"
                checked={tasks_data.gamas.indexOf(gama.name) > -1}
                style={{ height: 0, width: 0 }}
              />
              {gama.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel style={{ fontSize: "0.75rem" }}>
          Tipos de vehiculo
        </InputLabel>
        <Select
          labelId="demo-mutiple-chip-label"
          id="vehicle_types"
          name="vehicle_types"
          multiple
          disabled={disabled}
          value={tasks_data.vehicle_types}
          onChange={e => {
            handleChange(e);
          }}
          input={<Input id="select-multiple-chip" />}
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(value => (
                <Chip
                  key={value}
                  label={value}
                  className={classes.chip}
                  clickeable={true}
                  onDelete={
                    provider_data.vehicle_types !== null &&
                    provider_data.vehicle_types !== undefined
                      ? provider_data.vehicle_types.find(
                          o => o.vehicle_type.name === value
                        )
                        ? e => {
                            handleDelete("vehicle_types", value);
                          }
                        : false
                      : ""
                  }
                  onMouseDown={e => {
                    onMouseDown(e);
                  }}
                />
              ))}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {vehicle_types.map(vehicle_type => (
            <MenuItem
              key={vehicle_type.id}
              value={vehicle_type.name}
              style={getStyles(vehicle_type.name, vehicle_type.name, theme)}
            >
              <Checkbox
                className="pr-4"
                color="primary"
                checked={
                  tasks_data.vehicle_types.indexOf(vehicle_type.name) > -1
                }
                style={{ height: 0, width: 0 }}
              />
              {vehicle_type.name} - {vehicle_type.hansa_description} (
              {vehicle_type.hansa_code})
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel style={{ fontSize: "0.75rem" }}>
          Servicios Adicionales
        </InputLabel>
        <Select
          labelId="demo-mutiple-chip-label"
          id="aditional_service"
          name="aditional_service"
          multiple
          disabled={disabled}
          value={tasks_data.aditional_service}
          onChange={e => {
            handleChange(e);
          }}
          input={<Input id="select-multiple-chip" />}
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(value => (
                <Chip
                  key={value}
                  label={value}
                  className={classes.chip}
                  clickeable={true}
                  onDelete={
                    provider_data.tasks !== null &&
                    provider_data.tasks !== undefined
                      ? provider_data.tasks.find(o => o.task.name === value)
                        ? e => {
                            handleDelete("tasks", value);
                          }
                        : false
                      : ""
                  }
                  onMouseDown={e => {
                    onMouseDown(e);
                  }}
                />
              ))}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {additional_services.map(aditional_service => (
            <MenuItem
              key={aditional_service.id}
              value={aditional_service.name}
              style={getStyles(
                aditional_service.name,
                aditional_service.name,
                theme
              )}
            >
              <Checkbox
                className="pr-4"
                color="primary"
                checked={
                  tasks_data.aditional_service.indexOf(aditional_service.name) >
                  -1
                }
                style={{ height: 0, width: 0 }}
              />
              {aditional_service.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="equipment_type_id"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Nivel de equipamiento
        </InputLabel>
        <Select
          native
          name="equipment_type_id"
          inputProps={{
            name: "equipment_type_id",
            className: "equipment_type_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          onChange={handleChange}
          disabled={disabled}
          value={tasks_data.equipment_type_id}
          input={<Input id="grouped-native-select" name="equipment_type_id" />}
        >
          <option value="" />
          {equipment_types.map(equipment_type => (
            <option id={equipment_type.id} value={equipment_type.id}>
              {equipment_type.name}
            </option>
          ))}
        </Select>
      </FormControl>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {tasks_data.tasks.map((val, idx) => {
        return (
          <React.Fragment>
            <div className="row">
              <Typography variant="caption">
                <FormControl className={classes.formControl}>
                  <InputLabel style={{ fontSize: "0.75rem" }}>
                    Tareas
                  </InputLabel>
                  <Select
                    labelId="demo-mutiple-chip-label"
                    id={"tasks." + idx}
                    name={"tasks." + idx}
                    multiple
                    disabled={disabled}
                    onChange={e => {
                      handleChange(e);
                    }}
                    value={val.tasks}
                    input={<Input id="select-multiple-chip" />}
                    renderValue={selected => (
                      <div className={classes.chips}>
                        {selected.map(value => (
                          <Chip
                            key={value}
                            label={value}
                            className={classes.chip}
                            clickeable={true}
                            onDelete={
                              provider_data.tasks !== null &&
                              provider_data.tasks !== undefined
                                ? provider_data.tasks.find(
                                    o => o.task.name === value
                                  )
                                  ? e => {
                                      handleDelete("tasks", value);
                                    }
                                  : false
                                : ""
                            }
                            onMouseDown={e => {
                              onMouseDown(e);
                            }}
                          />
                        ))}
                      </div>
                    )}
                    MenuProps={MenuProps}
                  >
                    {tasks.map(task => (
                      <MenuItem
                        key={task.id}
                        data-id={task.id}
                        dataid={task.id}
                        id={task.id}
                        value={task.name}
                        style={getStyles(task.name, task.name, theme)}
                      >
                        <Checkbox
                          className="pr-4"
                          color="primary"
                          checked={val.tasks.indexOf(task.name) > -1}
                          style={{ height: 0, width: 0 }}
                        />
                        {task.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Typography>

              <FormControl
                className="mt-3 mr-2"
                style={{ minWidth: 150, fontSize: "0.75rem" }}
                name={"performed_type_id." + idx}
              >
                <InputLabel
                  htmlFor="grouped-native-select"
                  autoWidth="true"
                  style={{ minWidth: 150, fontSize: "0.75rem" }}
                >
                  Donde se realiza la tarea
                </InputLabel>
                <Select
                  native
                  name={"performed_type_id." + idx}
                  inputProps={{
                    name: "performed_type_id." + idx,
                    className: "performed_type_id." + idx
                  }}
                  style={{ minWidth: 150, fontSize: "0.75rem" }}
                  onChange={handleChange}
                  disabled={disabled}
                  value={val.performed_type_id}
                  input={
                    <Input
                      id="grouped-native-select"
                      name="equipment_type_id"
                    />
                  }
                >
                  <option value="" />
                  {performed_types.map(performed_type => (
                    <option id={performed_type.id} value={performed_type.id}>
                      {performed_type.name}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <div
                class="mt-4"
                style={{ width: "min-content", display: "inline-flex" }}
              >
                <IconButton
                  size="small"
                  className={classes.iconButton}
                  onClick={e => {
                    handleRemoveItem(e, idx);
                  }}
                  disabled={tasks_data.tasks.length == 1 ? true : false}
                >
                  <RemoveIcon className={classes.deleteIcon} />
                </IconButton>
                <IconButton
                  size="small"
                  className={classes.iconButton}
                  onClick={e => {
                    handleAddItem(e);
                  }}
                >
                  <AddIcon className={classes.deleteIcon} />
                </IconButton>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

ProvidersTasks.defaultProps = {
  type: "text",
  className: "",
  disabled: false
};

ProvidersTasks.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["text", "number", "password"]),
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default ProvidersTasks;
